import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';

export const CONSTANTS_GENERATION__value_default = {
  CLEAN_GUIDANCE_RESCALE: 0,
  CLEAN_GUIDANCE_SCALE: 1,
  CLEAN_SEED: 0,
  CLEAN_IMAGE_CANVAS_STRENGTH: 0,
  CLEAN_IMAGE: new DTO__image_asset().clone({ hash_sha256_content: ENUM__string_id_empty.HASH_SHA256 }),

  IMAGE_CANVAS_STRENGTH: 50,
  LORA_WEIGHT_MASTER: 100.0,

  LORA_WEIGHT: 0.0,
  LORA_WEIGHT_LCM: 100.0,

  TOKEN_WEIGHT: 1,
};
